var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloneMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81817 1.27272C3.81817 0.569812 4.38799 -5.09085e-06 5.09089 0L12.7272 5.66296e-05C13.4301 5.91751e-05 13.9999 0.569876 13.9999 1.27278V8.90905C13.9999 9.61197 13.4301 10.1818 12.7272 10.1818H12.0909C11.7394 10.1818 11.4545 9.89687 11.4545 9.54541V4.77273C11.4545 3.54266 10.4573 2.54547 9.22723 2.54547H4.45453C4.10307 2.54547 3.81817 2.26057 3.81817 1.90911V1.27272ZM0 5.091C0 4.38809 0.569817 3.81828 1.27272 3.81828L8.90905 3.81829C9.61198 3.81829 10.1818 4.38811 10.1818 5.09101V12.7273C10.1818 13.4302 9.61198 14 8.90905 14H1.27272C0.569817 14 0 13.4302 0 12.7273V5.091Z",
    fill: "#721C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneMenuIcon);
export default __webpack_public_path__ + "static/media/clone-menu-icon.5aea0500d857610e0eee961de462211e.svg";
export { ForwardRef as ReactComponent };